import "../../_namespaces.js";
import "../../_generated_templates.js";
import "../../../application/forms/international_phone_input.js";
import "#vendor/jquery_plugins/jquery.mask.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.AssessmentSubmitterInfo = class AssessmentSubmitterInfo extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.validateSubmitterInfo = this.validateSubmitterInfo.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.triggerSubmitterInfoChanged = this.triggerSubmitterInfoChanged.bind(this);
    this.initializePhoneInput = this.initializePhoneInput.bind(this);
    this.storeInternationalPhoneNumber = this.storeInternationalPhoneNumber.bind(this);
    this.isPhoneInputInitalized = this.isPhoneInputInitalized.bind(this);
    this.dirtyInput = this.dirtyInput.bind(this);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    this.phoneNumberJSPromise = this.initializePhoneInput();

    // Utilize the mask functionality for date fields
    this.$(".date-mask").mask("09/09/0000");

    this.dirtyInput(this.$('.attribute :input[value!=""]')); // Dirty attributes with existing values
    return this;
  }

  // EVENT HANDLERS

  handleAttributeChange(event) {
    const input = jQuery(event.target);
    this.dirtyInput(input);
    this.model.set(humps.camelize(input.attr("name")), input.val());
    return this.triggerSubmitterInfoChanged();
  }

  handlePhoneNumberChange(event) {
    return this.storeInternationalPhoneNumber();
  }

  // HELPER FUNCTIONS

  validateSubmitterInfo() {
    if (!Modernizr.formvalidation) {
      return true;
    }
    let valid = true;

    let input = this.$("[name=first_name]").get(0);
    if (input != null) {
      valid = valid && input.checkValidity();
    }

    input = this.$("[name=last_name]").get(0);
    if (input != null) {
      valid = valid && input.checkValidity();
    }

    input = this.$("[name=email_address]").get(0);
    if (input != null) {
      valid = valid && input.checkValidity();
    }

    input = this.$("[name=birthday]").get(0);
    if (input != null) {
      valid = valid && input.checkValidity();
    }

    input = this.$("[name=phone_number]").get(0);
    if (input != null) {
      const validPhone = this.validatePhoneNumber(input);
      if (jQuery(input).attr("required")) {
        valid = valid && validPhone;
      }
    }

    input = this.$("[name=zip_code]").get(0);
    if (input != null) {
      valid = valid && input.checkValidity();
    }

    return valid;
  }

  validatePhoneNumber(input) {
    if (this.isPhoneInputInitalized() && !jQuery(input).intlTelInput("isValidNumber")) {
      input.setCustomValidity("Invalid Pattern");
      return false;
    } else {
      input.setCustomValidity("");
      return true;
    }
  }

  triggerSubmitterInfoChanged() {
    return this.$el.trigger(AssessmentViewer.Events.SubmitterInfo.changed);
  }

  initializePhoneInput() {
    return window.Sparkle.Forms.loadInternationalPhoneInput(this.$('input[type="tel"]'));
  }

  storeInternationalPhoneNumber() {
    return this.model.set("phoneNumber", this.$('input[type="tel"]').intlTelInput("getNumber"));
  }

  isPhoneInputInitalized() {
    return this.phoneNumberJSPromise.state() === "resolved";
  }

  dirtyInput(input) {
    return input.addClass("show-validation");
  }
};
AssessmentViewer.Views.AssessmentSubmitterInfo.prototype.tagName = "div";
AssessmentViewer.Views.AssessmentSubmitterInfo.prototype.className = "assessment-view assessment-view--submitter-info";
AssessmentViewer.Views.AssessmentSubmitterInfo.prototype.template = _.template(
  AssessmentViewer.Templates.Assessment.submitter_info,
);

AssessmentViewer.Views.AssessmentSubmitterInfo.prototype.events = {
  input: "handleAttributeChange",
  'change input[type="tel"]': "handlePhoneNumberChange",
};
